import './NavigationSteps.scss';
export const NavigationSteps = ({ stepsLength, currentStep, setStep }) => {
  const steps = Array.from({ length: stepsLength }, (_, i) => i + 1);

  return (
    <div className="navigation-steps">
      {steps.map((stepNumber) => (
        <button
          key={stepNumber}
          className={stepNumber === currentStep ? "active" : ""}
          onClick={() => setStep(stepNumber)}
        >
          {stepNumber}
        </button>
      ))}
    </div>
  );
};
